import React, { Component } from 'react';
import styled from 'styled-components';

import Color from '../../utils/colors';
import mediaWidth from '../../utils/mediaWidth/mediaWidth';

import AnimationContainer from '../../common/FadeAnimation';
import Headline from '../../common/Headline';
import ContactsBlock from '../../common/ContactsBlock';

class Contacts extends Component {
    render() {
        const { className, page } = this.props;

        return (
            <Root className={className}>
                <AnimationContainer external="parent">
                    <HeadlineStyled page={page}>
                        Свяжитесь с&nbsp;нами
                    </HeadlineStyled>
                </AnimationContainer>
                <AnimationContainer external="parent" delay={150}>
                    <ContactsBlock />
                </AnimationContainer>
            </Root>
        );
    }
}

const Root = styled.div`
    /* width: 100%; */

    background: trasparent;

    color: ${Color.TEXT_PRIMARY};
`;

const HeadlineStyled = styled(Headline)`
    font-size: 32px;
    line-height: 32px;

    text-transform: uppercase;
    margin-bottom: 40px;

    ${mediaWidth.m} {
        font-size: 48px;
        line-height: 48px;

        margin-bottom: 56px;
    }

    ${mediaWidth.l} {
        font-size: 32px;
        line-height: 32px;
    }
`;

export default Contacts;
